// src/components/DisclosureAgreement.tsx

import { CheckIcon, Radio, Stack } from "@mantine/core";
import { useTaxOrganizerStore } from "../../../../../utils/stores/taxOrganizerStore";
import "./DisclosureAgreement.scss";

interface DisclosureAgreementProps {
  parentObjectName: string;
}

const DisclosureAgreement = ({
  parentObjectName,
}: DisclosureAgreementProps) => {
  const { responses, updateResponses } = useTaxOrganizerStore();

  const handleRadioChange = (value: string) => {
    updateResponses({
      ...responses,
      [parentObjectName]: {
        ...responses[parentObjectName || ""],
        disclosureAccepted: value === "accept",
      },
    });
  };

  return (
    <div className="disclosure-container">
      <h1>
        Just a step left! Please review the disclosure statement for your
        information
      </h1>

      <div className="disclosure-statement">
        <Radio.Group
          name="disclosureAgreement"
          label={
            <p>
              By submitting your information, you confirm that all provided
              details are accurate and complete to the best of your knowledge
              and understand that the quality of tax preparation relies on the
              accuracy of this information.
            </p>
          }
          value={
            responses?.[parentObjectName]?.disclosureAccepted
              ? "accept"
              : "reject"
          }
          onChange={handleRadioChange}
        >
          <Stack mt="xs">
            <Radio icon={CheckIcon} value="accept" label="I accept" />
            <Radio icon={CheckIcon} value="reject" label="I do not accept" />
          </Stack>
        </Radio.Group>
      </div>
    </div>
  );
};

export default DisclosureAgreement;
